export function trimSplit(text: string, separator: string = "\n"): string[] {
	return text
		.split(separator)
		.map((s) => s.trim())
		.filter((s) => s !== "");
}
